//Default
import logo from "../static/skills/react.png";
//Frontend
import react from "../static/skills/react.png";
import javascript from "../static/skills/javascript.png";
import typescript from "../static/skills/typescript.png";
import html from "../static/skills/html.png";
import css from "../static/skills/css.png";
import tailwindcss from "../static/skills/tailwindcss.png";
//Backend
import python from "../static/skills/python.png";
import django from "../static/skills/django.png";
import flask from "../static/skills/flask.png";
import firebase from "../static/skills/firebase.png";
import sql from "../static/skills/sql.png";
import postgresql from "../static/skills/postgresql.png";
import sqlite from "../static/skills/sqlite.png";
import celery from "../static/skills/celery.png";
import rabbitmq from "../static/skills/rabbitmq.png";
//Others
import git from "../static/skills/git.png";
import docker from "../static/skills/docker.png";
import nginx from "../static/skills/nginx.png";
import gcp from "../static/skills/gcp.png";
import java from "../static/skills/java.png";
import c from "../static/skills/c.png";
import cpp from "../static/skills/cpp.png";
import cs from "../static/skills/cs.png";
import solidity from "../static/skills/solidity.png";
import haskell from "../static/skills/haskell.png";
import unity from "../static/skills/unity.png";
import procreate from "../static/skills/procreate.png";

export let frontend_skills = [
  [react, "React"],
  [javascript, "JavaScript"],
  [typescript, "TypeScript"],
  [html, "Html"],
  [css, "Css"],
  [tailwindcss, "Tailwind CSS"],
];

export let backend_skills = [
  [python, "Python"],
  [django, "Django"],
  [flask, "Flask"],
  [firebase, "Firebase"],
  [sql, "SQL"],
  [postgresql, "PostgreSQL"],
  [sqlite, "SQLite"],
  [celery, "Celery"],
  [rabbitmq, "RabbitMQ"],
];

export let other_skills = [
  [git, "Git"],
  [docker, "Docker"],
  [nginx, "Nginx"],
  [gcp, "GCP"],
  [java, "Java"],
  [c, "C"],
  [cpp, "C++"],
  [cs, "C#"],
  [solidity, "Solidity"],
  [haskell, "Haskell"],
  [unity, "Unity"],
  [procreate, "Procreate"],
];
